import {useEffect} from 'react';
import Analytics from 'utils/Analytics';
import {readSeverityFromUrl} from 'surveys/osa_funnel/survey/severity';
import {useGlp1Modality} from 'surveys/osa_funnel/hooks/useGlp1Modality';
import {modalityToVariant} from './paywallCopy';
import styles from './OsaPaywallConfirm.module.css';
import riseExpertCareLogo from 'surveys/osa_funnel/assets/rise-expert-care-logo.svg';

/** Post-purchase confirmation. Lands here after Glp1PaymentBlock finishes
 *  the /stripe-glp1-finalize call successfully. The screen sets
 *  expectations for what happens next (clinician review, email confirm,
 *  shipping). */
export const OsaPaywallConfirm = () => {
  const modality = useGlp1Modality();
  const variant = modalityToVariant(modality);

  useEffect(() => {
    Analytics.track('GLP-1 Paywall Confirmation Viewed', {
      variant,
      severity: readSeverityFromUrl(),
    });
  }, [variant]);

  return (
    <div className={styles.root}>
      <div className={styles.brandRow}>
        <img src={riseExpertCareLogo} alt="RISE Expert Care" className={styles.brandLogo} />
      </div>

      <div className={styles.card}>
        <span className={styles.checkBubble}>
          <svg width={28} height={28} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4}>
            <path d="M5 13 L 10 18 L 19 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>

        <h1 className={styles.title}>You&apos;re in.</h1>
        <p className={styles.subtitle}>
          We&apos;ve sent a confirmation to your email. A licensed clinician will review your case — usually the same
          day.
        </p>

        <div className={styles.steps}>
          <div className={styles.step}>
            <span className={styles.stepBullet}>1</span>
            <p className={styles.stepText}>
              Watch your inbox for your clinician&apos;s decision. If treatment isn&apos;t a fit, you&apos;ll be
              refunded automatically.
            </p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepBullet}>2</span>
            <p className={styles.stepText}>
              {variant === 'compounded'
                ? 'If you’re approved, your nightly drops ship from a state-licensed pharmacy — usually within 3–4 days.'
                : 'If you’re approved, Zepbound® ships cold-chain — usually within 3–4 days.'}
            </p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepBullet}>3</span>
            <p className={styles.stepText}>
              Open the RISE app any time to message your care team and follow your sleep + medication plan.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OsaPaywallConfirm;
